/**
 * @param {Function} func
 * @param {number} delay
 * @return {*}
 */
import { useStore } from '@/stores/index.js'
export function throttle(fn, delay = 300) {
  let timer = null
  return function (...args) {
    if (timer == null) {
      timer = setTimeout(() => {
        fn.call(this, ...args)

        clearTimeout(timer)
        timer = null
      }, delay)
    }
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = null
        args = null
      }
    }
  }

  return function (...args) {
    const a = () => {
      timestamp = +new Date()
      const callNow = immediate && !timeout
      // 如果延时不存在，重新设定延时
      if (!timeout) timeout = setTimeout(later, wait)
      if (callNow) {
        result = func.apply(this, args)
        context = null
        args = null
      }
      return result
    }
    a()
  }
}

/**
 * 参数处理
 * @param {*} params  参数
 */
export function tansParams(params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName]
    const part = `${encodeURIComponent(propName)}=`
    if (value !== null && value !== '' && typeof value !== 'undefined') {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== '' && typeof value[key] !== 'undefined') {
            const params = `${propName}[${key}]`
            const subPart = `${encodeURIComponent(params)}=`
            result += `${subPart + encodeURIComponent(value[key])}&`
          }
        }
      } else {
        result += `${part + encodeURIComponent(value)}&`
      }
    }
  }
  return result
}

export function formatTime(dateStr) {
  if (!dateStr) return '--'
  const _week = {
    0: 'Sun',
    1: 'Mon',
    2: 'Tue',
    3: 'Wed',
    4: 'Thur',
    5: 'Fri',
    6: 'Sat',
  }
  try {
    const date = new Date(dateStr)
    const weekDay = _week[date.getDay()]
    return `${weekDay}. ${dateStr}`
  } catch (error) {
    console.error('Date parsing error:', error)
    return '--'
  }
}

// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) return null

  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) time = parseInt(time)
    else if (typeof time === 'string')
      time = time
        .replace(/-/gm, '/')
        .replace('T', ' ')
        .replace(/\.[\d]{3}/gm, '')

    if (typeof time === 'number' && time.toString().length === 10) time = time * 1000

    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') return ['日', '一', '二', '三', '四', '五', '六'][value]
    if (result.length > 0 && value < 10) value = `0${value}`

    return value || 0
  })
  return time_str
}

/**
 * 滚动到最底部
 */
export function scrollToBottom() {
  (function smoothscroll() {
    const currentScroll = document.documentElement.scrollTop || document.body.scrollTop // 已经被卷掉的高度
    const clientHeight = document.documentElement.clientHeight // 浏览器高度
    const scrollHeight = document.documentElement.scrollHeight // 总高度
    if (scrollHeight - 10 > currentScroll + clientHeight) {
      window.requestAnimationFrame(smoothscroll)
      window.scrollTo(0, currentScroll + (scrollHeight - currentScroll - clientHeight) / 2)
    }
  })()
}
/**
 *
 * @param {*} m 开始值
 * @param {*} n 结束值
 * @returns
 */
function rand(m, n) {
  const num = Math.ceil(Math.random() * (n - m + 1) + m - 1)
  return num <= 0 ? 0 : num
}

/**
 *
 * @param {*} number 取几个值
 * @param {*} rangeStart 开始值
 * @param {*} rangeEnd 结束值
 * @param {*} allowRepeat 是否允许重复
 * @returns
 */
function randomNumbers(rangeStart, rangeEnd, number, data, allowRepeat) {
  const num = rand(rangeStart, rangeEnd)
  if (allowRepeat) {
    data.push(num)
  } else {
    if (!data.includes(num)) data.push(num)
  }
  if (data.length < number) randomNumbers(rangeStart, rangeEnd, number, data, allowRepeat)
}

export function randomGruopNumber(rangeStart, rangeEnd, number, allowRepeat) {
  const groupNumber = []
  randomNumbers(rangeStart, rangeEnd, number, groupNumber, allowRepeat)
  return groupNumber
}
/**
 *
 * @param {*} srt 处理的字符串
 */
export function getNumber(srt, lastBlueNumbernum, bNumber) {
  const r = {}
  const num_Array = srt.split(',')
  const _store = useStore()
  const _num = _store.lotteryConfig.maxBlueNumber || lastBlueNumbernum
  if (_num) {
    if (bNumber) {
      r.blueNumber = bNumber
    } else {
      const blueNumber = []
      for (let i = 0; i < _num; i++) blueNumber.unshift(Number(num_Array.pop()))

      r.blueNumber = blueNumber
    }
  }
  const numbers = num_Array.map(n => Number(n))
  r.numbers = numbers
  return r
}
/**
 * 获取图片路径
 * @param {*} imgPath
 * @returns
 */
export const requireImg = imgPath => {
  return new URL(`../assets/images/${imgPath}`, import.meta.url).href
}
// 删除loading占位
export const removeLoading = () => {
  const startLoading = document.getElementById('startLoading')
  if (startLoading) {
    startLoading.remove()
  }
}
/**
 * 金额格式化
 * @param {*} value 金额
 * @param {*} currency 货币
 * @param {*} decimals 小数位数
 * @returns
 */
export function currency(value, currency = '₹', decimals = 2) {
  return formatAmountDisplay(value, {
    currencySymbol: currency,
    decimals: decimals,
  })
}

/**
 * 金额展示格式化
 * @param {number|string} value 金额值
 * @param {object} options 配置项
 * @param {boolean} options.showSign 是否显示正负号（默认 false）
 * @param {string} options.currencySymbol 货币符号（默认空）
 * @param {'prefix'|'suffix'} options.currencyPosition 货币符号位置（默认 prefix）
 * @param {boolean} options.absValue 是否取绝对值展示（默认 true）
 * @param {number|null} options.decimals 小数位；null 表示不强制位数（默认 null）
 * @param {boolean} options.trimTrailingZeros 是否去掉末尾 0（默认 true）
 * @param {boolean} options.spaceBetweenSignAndAmount 正负号与金额间是否加空格（默认 true）
 * @param {boolean} options.spaceBetweenCurrencyAndNumber 货币符号与数字间是否加空格（默认 false）
 * @returns {string}
 */
export function formatAmountDisplay(value, options = {}) {
  const {
    showSign = false,
    currencySymbol = '₹',
    currencyPosition = 'prefix',
    absValue = true,
    decimals = 2,
    trimTrailingZeros = true,
    spaceBetweenSignAndAmount = true,
    spaceBetweenCurrencyAndNumber = false,
  } = options

  const numericValue = Number(value || 0)
  if (Number.isNaN(numericValue)) return ''

  const sign = numericValue > 0 ? '+' : numericValue < 0 ? '-' : ''
  const displayValue = absValue ? Math.abs(numericValue) : numericValue

  let numberText = ''
  if (decimals == null) {
    // 不强制小数位：整数不带 .00，小数保留原始有效位
    numberText = Number.isInteger(displayValue) ? String(displayValue) : String(displayValue)
  } else {
    // 强制小数位：不足补 0，多余直接截断
    const factor = 10 ** decimals
    // 多余截断
    // const truncated = Math.trunc(displayValue * factor) / factor
    // numberText = truncated.toFixed(decimals)

    //四舍五入
    const rounded = Math.round(displayValue * factor) / factor
    numberText = rounded.toFixed(decimals)
  }
  if (trimTrailingZeros && numberText.includes('.')) {
    numberText = numberText.replace(/0+$/, '').replace(/\.$/, '')
  }

  const gap = spaceBetweenCurrencyAndNumber ? ' ' : ''
  let amountText = numberText
  if (currencySymbol) {
    amountText =
      currencyPosition === 'suffix' ? `${numberText}${gap}${currencySymbol}` : `${currencySymbol}${gap}${numberText}`
  }

  if (showSign && sign) {
    return `${sign}${spaceBetweenSignAndAmount ? ' ' : ''}${amountText}`
  }

  return amountText
}

/**
 * 按印度金额单位格式化（K / Lakhs / Crores）
 * - 大于阈值时自动缩写
 * - 默认阈值：10000
 */
// export function formatAmountWithIndianUnit(value, options = {}) {
//   const { currencySymbol = '₹', threshold = 10000, decimals = 2 } = options

//   const amount = Number(value)
//   if (Number.isNaN(amount)) return `${currencySymbol}0`
//   if (Math.abs(amount) < threshold) return currency(amount, currencySymbol, 0)

//   const abs = Math.abs(amount)
//   const sign = amount < 0 ? '-' : ''
//   let unit = 'K'
//   let scaled = abs / 1000

//   if (abs >= 10000000) {
//     unit = 'Crores'
//     scaled = abs / 10000000
//   } else if (abs >= 100000) {
//     unit = 'Lakhs'
//     scaled = abs / 100000
//   }

//   const text = Number.isInteger(scaled) ? `${scaled}` : scaled.toFixed(decimals).replace(/\.?0+$/, '')
//   return `${sign}${currencySymbol}${text} ${unit}`
// }

export function formatAmountWithIndianUnit(value, options = {}) {
  const { currencySymbol = '₹', decimals = 2 } = options

  const amount = Number(value)
  if (Number.isNaN(amount)) return `${currencySymbol}0`

  const abs = Math.abs(amount)
  const sign = amount < 0 ? '-' : ''

  // 小于 100000 正常显示
  if (abs < 100000) {
    return currency(amount, currencySymbol, 0)
  }

  let unit = 'Lakhs'
  let scaled = abs / 100000

  // 超过 1000w（1 Crore）
  if (abs >= 10000000) {
    unit = 'Crores'
    scaled = abs / 10000000
  }
  const text = Number.isInteger(scaled) ? `${scaled}` : scaled.toFixed(decimals).replace(/\.?0+$/, '')

  return `${sign}${currencySymbol}${text} ${unit}`
}

export function formatMatchTime(timestamp, matchStatus) {
  if (!timestamp) return { date: '', time: '' }

  const now = new Date()
  const targetDate = new Date(timestamp)
  const diff = targetDate.getTime() - now.getTime()
  const diffSeconds = Math.floor(diff / 1000)
  const diffMinutes = Math.floor(diffSeconds / 60)
  const diffHours = Math.floor(diffMinutes / 60)
  let isTodsyLessThan10Hours = false
  // 格式化时间: 10:00pm / 09:05am
  const hours24 = targetDate.getHours()
  const minutes = targetDate.getMinutes()
  const ampm = hours24 >= 12 ? ' PM' : ' AM'
  const hours12 = hours24 % 12 || 12
  const timeStr = `${hours12}:${minutes.toString().padStart(2, '0')}${ampm}`

  // 判断日期
  const nowDate = now.getDate()
  const nowMonth = now.getMonth()
  const nowYear = now.getFullYear()
  const targetDay = targetDate.getDate()
  const targetMonth = targetDate.getMonth()
  const targetYear = targetDate.getFullYear()

  const isToday = nowDate === targetDay && nowMonth === targetMonth && nowYear === targetYear
  const isTomorrow = targetDay === nowDate + 1 && targetMonth === nowMonth && targetYear === nowYear

  let dateStr

  if (isToday) {
    if (diffSeconds < 0) {
      //赛前倒计时结束后展示红色超时文案
      if (matchStatus && matchStatus === 1) {
        isTodsyLessThan10Hours = true
        dateStr = "Time's Out"
      } else {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        dateStr = `${targetDay} ${months[targetMonth]}`
      }
    } else if (diffSeconds < 60) {
      // 小于1分钟
      isTodsyLessThan10Hours = true
      dateStr = `${diffSeconds}s`
    } else if (diffMinutes < 60) {
      // 小于1小时
      isTodsyLessThan10Hours = true
      dateStr = `${diffMinutes}m`
    } else if (diffHours < 24) {
      // 小于24小时
      const remainingMinutes = diffMinutes % 60
      isTodsyLessThan10Hours = true
      dateStr = `${diffHours}h :${remainingMinutes.toString().padStart(2, '0')}m`
    } else {
      dateStr = 'Today'
    }
  } else if (isTomorrow) {
    dateStr = 'Tomorrow'
  } else {
    // 其他日期显示具体日期和月份
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    dateStr = `${targetDay} ${months[targetMonth]}`
  }
  return { date: dateStr, time: timeStr, isTodsyLessThan10Hours }
}
